import React, { useState } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useHistory } from "react-router-dom";
import TeamService from "services/TeamService";
import Loader from "components/Loader";
import CustomInput from "components/CustomInput/CustomInput";
import CustomModal from "components/CustomModal/CustomModal";
import Button from "components/CustomButton";
import { useGlobalContext } from "store/contexts/globalContext";

export default function JoinTeam({ createMSTeam = null, selectTeam = null }) {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const { createTeam } = useGlobalContext();

  const formik = useFormik({
    initialValues: {
      code: "",
    },
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: Yup.object().shape({
      code: Yup.string()
        .matches(/^[a-zA-Z0-9\s]+$/)
        .min(4, "Team name must be between 4 to 50 characters.")
        .max(50, "Team name must be between 4 to 50 characters.")
        .required(),
    }),
    onSubmit: async (values) => {
      try {
        setLoading(true);
        var response = await TeamService.joinTeam(values.code);
        if (createMSTeam) {
          createMSTeam(response.data.data);
        }

        formik.setFieldValue("code", "");

        setLoading(false);
        setIsOpen(false);

        return !selectTeam
          ? joinTeam(response.data.data)
          : selectTeam(response.data.data);
      } catch (error) {
        if (error.response) {
          setErrorState("The code you provided was invalid");
          setLoading(false);
        }
      }
      setLoading(false);
    },
  });

  const joinTeam = (team) => {
    history.push(`/teams/${team?.id}`);
    createTeam(team);
  };

  const setErrorState = (message) => {
    if (message) {
      setErrorMessage("The code you provide was invalid.");
      setTimeout((_) => {
        setErrorMessage("");
      }, 4000);
    }
  };

  const handleCloseModal = () => {
    setIsOpen(false);
    formik.resetForm();
  };

  return (
    <>
      <Button
        type="button"
        onClick={() => setIsOpen(true)}
        buttonClass="light-gray-btn ms-3 d-inline-block mb-3"
        name="Join Team"
      />
      <CustomModal
        show={isOpen}
        onClose={handleCloseModal}
        modalClass="modal-dialog"
      >
        <div className="modal fade popup-modal">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-body">
                <h5>Join a Team</h5>
                <small className="fs-12 color-light">
                  Being part of a team is the first step.
                </small>
                <div className="fs-11 color-blue mt-3">
                  Please enter the code received in your email below to join a
                  team.
                </div>
                <form noValidate onSubmit={formik.handleSubmit}>
                  <CustomInput
                    id={"code"}
                    inputProps={{
                      type: "text",
                      placeholder: "Enter Your Code Here",
                      ...formik.getFieldProps("code"),
                      error: formik.errors.code,
                    }}
                    inputClass="full_w mt-0"
                  />
                  {errorMessage && (
                    <div className="errorMessage">{errorMessage}</div>
                  )}
                  <Button
                    type="button"
                    buttonClass=" light-gray-btn me-2"
                    name="Cancel"
                    onClick={handleCloseModal}
                  />
                  <Button
                    name={
                      !loading ? "Join Team" : <Loader width={25} height={25} />
                    }
                    buttonClass=" light-gray-btn"
                    disabled={loading && true}
                  />
                </form>
              </div>
            </div>
          </div>
        </div>
      </CustomModal>
    </>
  );
}
